import { render, staticRenderFns } from "./CategoryDescriptionComponent.vue?vue&type=template&id=1b806956&"
import script from "./CategoryDescriptionComponent.vue?vue&type=script&lang=js&"
export * from "./CategoryDescriptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports